import React, { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import reportWebVitals from './reportWebVitals';
import Loading from './components/sharedElements/Loading';
import { setCurrentUser, setCurrentUserInfo, getCurrentUserInfo } from './helpers/Utils';
import { get } from './helpers/Request';
// import * as Sentry from '@sentry/react';
// import { BrowserTracing } from '@sentry/tracing';
import { adtrace } from './helpers/Request';
import Adtrace from "web-adtrace"

const App = React.lazy(() => import(/* webpackChunkName: "App" */ './App'));

const Main = (props) => {
  const getUserInfo = () => {
    get('/user/info', {}, (data) => {
      setCurrentUserInfo(data.data);
    });
  };
  useEffect(() => {
    const server = window.location.hostname;
    let host = null;
    switch (server) {
      case 'app.7030.ir':
        host = 'Main';
        break;
      case 'app.7030x.ir':
        host = 'Beta';
        break;
      case 'pwa.70si.ir':
        host = 'Dev';
        break;
      case "app.haftadsi.com":
        host = 'Com';
        break
      case "localhost":
        host = "Local";
    }

    // Sentry.init({
    //   dsn: "https://4e1f0db3a5dd4f7991cd621af0002858@sentry.7o3o.ir/4",
    //   integrations: [new BrowserTracing()],
    //   tracesSampleRate: 1.0,
    //   environment: `PWA-${host}`
    // });
  }, []);

  useEffect(() => {
    let url = window.location.href;
    const lastItem = (url) => url.substring(url.lastIndexOf('/') + 1);
    const pathName = window.location.pathname.split('/');
    if (url.includes('/r/')) {
      let item = lastItem(url);
      sessionStorage.setItem('webReferId', item);
    }
    if (url.includes('/token/')) {
      let item = lastItem(url);
      sessionStorage.setItem('token', item);
      const userToken = {
        access_token: `${item}`,
        token_type: 'Bearer',
      };
      setCurrentUser(userToken);
      getUserInfo();
    }

    if (url.includes('/s/s/')) {
      sessionStorage.setItem('deepId', pathName[3]);
      sessionStorage.setItem('deepStatus', 'shop');
    } else if (url.includes('/s/p/')) {
      sessionStorage.setItem('deepId', pathName[3]);
      sessionStorage.setItem('deepStatus', 'product');
    } else if (url.includes('/s/c/')) {
      sessionStorage.setItem('deepId', pathName[3]);
      sessionStorage.setItem('subDeepId', pathName[4]);
      sessionStorage.setItem('deepStatus', 'category');
    } else if (url.includes('/shopPorfile/comment/')) {
      sessionStorage.setItem('prdIdForComment', pathName[3]);
    } else if (url.includes('/charity/moreCharityItems')) {
      const urlParams = new URLSearchParams(window.location.search);
      let id = urlParams.get("categoryId");
      sessionStorage.setItem('charityId', id);
    } else {
      sessionStorage.removeItem('deepId');
      sessionStorage.removeItem('deepStatus');
    }
  }, []);

  useEffect(() => {

    Adtrace.initSdk(adtrace);

    // function uuidv4() {
    //   return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    //     (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    //   );
    // }
    // const adTraceUID = localStorage.getItem('adTraceUID');
    // if (!adTraceUID) {
    //   localStorage.setItem('adTraceUID', uuidv4());
    // }
    // const userUID = localStorage.getItem('userUID', uuidv4());
    // if (!getCurrentUserInfo() && !userUID) {
    //   localStorage.setItem('userUID', uuidv4());
    // }
    // adtrace.trackSession(function (result) {
    // }, function (errorMsg, error) {
    //   console.log(errorMsg, error);
    // }
    // );
  }, []);

  return (
    <Provider store={configureStore()}>
      <Suspense fallback={<Loading />}>
        <App />
      </Suspense>
    </Provider>
  );
};

ReactDOM.render(<Main />, document.getElementById('root'));

reportWebVitals();

// const mapStateToProps = () => {
// 	return {};
// };

// export default injectIntl(
// 	connect(mapStateToProps, {
// 		pushToForm: pushTo,
// 		updateTabAction: updateTab
// 	})(Main)
// );
